/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, useRef} from 'react';
import './Search.css'
import axios from 'axios';
import { UserModel } from '../../auth/models/UserModel';
import { shallowEqual } from 'react-redux';
import { RootState } from '../../../../setup';
import { useSelector } from 'react-redux';
import Select from '../../../components/react-select';

const SelectSearchs = (props: any) => {
    const { value, handleChange, partner, disabled } = props;
    const [options, setOptions] = useState<any[]>([]);
    const [searchOptions, setSearchOptions] = useState<any[]>([]);
    const [searchvalue, setSearchValue] = useState<string>("");
    const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel;

    const handlechange = (event: any) => {
        handleChange("", event.value);
        setSearchValue(event)
    }

    const handleInputChange = (event: any) => {
        handleChange("", event?.target.value)
        setSearchValue(event?.target.value)
    }

    useEffect(() => {
        setSearchValue(value);
    }, [value])

    const API_URL = process.env.REACT_APP_ENV === 'prod' ? process.env.REACT_APP_API_PROD_URL : process.env.REACT_APP_API_DEV_URL
    const saltid = user?.saltid;
    const salt = user?.salt;

    useEffect(() => {
        axios.post(`${API_URL}/search/autocomplete`, { search: "", partner, salt, saltid })
            .then((res) => {
                const { data } = res;
                const ooptions = [...data['queries']];
                const newOptions = ooptions.map(({ value }: any) => ({
                    value: value,
                    label: value
                }))
                setOptions([...newOptions]);
            })
            .catch()
        // eslint-disable-next-line
    }, [partner])

    const onInputChange = (e: any) => {
        if(e) {
            handleChange("", e);
        }
        setSearchValue(e);
        if(e.length > 0) {
            setSearchOptions(options);
        } else {
            setSearchOptions([]);
        }
    }

    const colourStyles = {
        control: (styles: any) => ({ ...styles, backgroundColor: '#F5F8FA', border: 'none' }),
        indicatorSeparator: () => ({display: 'none'}),
        indicatorsContainer: (styles: any) => ({...styles, paddingRight: 4, color: 'red', display: 'none'})
      };

    const onMenuClose = () => {
        setOpen(false)
        if(!searchvalue) {
            handleChange("", searchvalue);
        }
    }

    const brandSelectRef = useRef(null)
    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = () => {
        setOpen(true)
        if (brandSelectRef && brandSelectRef.current) {
            //@ts-ignore
            brandSelectRef?.current?.focus()
            //@ts-ignore
            // brandSelectRef?.current?.select()
          }
      
    }

    useEffect(() => {
        setSearchValue(value);
          //eslint-disable-next-line
    }, [open])

    return (
        <>
        {
            open ?
                <Select
                    className='react-select'
                    placeholder=""
                    value={{value: searchvalue, label: searchvalue}}
                    onChange={handlechange}
                    onInputChange={onInputChange} 
                    onMenuClose={onMenuClose} 
                    options={searchOptions}
                    ref={brandSelectRef}
                    defaultMenuIsOpen={true}
                    defaultInputValue={searchvalue}
                    autoFocus
                    isDisabled={disabled}
                    isClearable={false}
                    styles={colourStyles}
                />
            :
            <div onClick={handleOpen}>
                <input
                    type="text"
                    className="form-control form-control-sm form-control-solid"
                    style={{fontSize: '13px',  fontWeight: 400}}
                    autoComplete='off'
                    placeholder=""
                    autoFocus
                    value={searchvalue}
                    onChange={handleInputChange}
                />
            </div>
        }
        </>
    )
}

export default SelectSearchs;